import { OverlayRef } from '@angular/cdk/overlay';
import { ComponentRef } from '@angular/core';
import { QimaOptionalType } from '@qima/ngx-qima';
import { Observable, Subject } from 'rxjs';

/**
 * A reference to the dialog itself.
 * Can be injected into the component added to the overlay and then used to close itself.
 */
export class DialogRef<T> {
  private readonly _afterClosedSubject$: Subject<QimaOptionalType<T>> = new Subject<QimaOptionalType<T>>();
  private readonly _beforeClosedSubject$: Subject<QimaOptionalType<T>> = new Subject<QimaOptionalType<T>>();
  private readonly _afterComponentInitSubject$: Subject<ComponentRef<unknown> | null> = new Subject<ComponentRef<unknown> | null>();

  public constructor(private readonly _overlayRef: OverlayRef) {}

  public close(result?: T): void {
    this._overlayRef.dispose();
    this._afterClosedSubject$.next(result);
    this._afterClosedSubject$.complete();
    document.body.style.overflow = '';
  }

  // subscribe to this method to get the componentRef
  public afterInit$(): Observable<ComponentRef<unknown> | null> {
    return this._afterComponentInitSubject$.asObservable();
  }

  public afterInit(target: ComponentRef<unknown> | null): void {
    this._afterComponentInitSubject$.next(target);
  }

  public confirmBeforeClose(result?: QimaOptionalType<T>): void {
    this._beforeClosedSubject$.next(result);
  }

  public beforeClosed$(): Observable<QimaOptionalType<T>> {
    return this._beforeClosedSubject$.asObservable();
  }

  public afterClosed$(): Observable<QimaOptionalType<T>> {
    return this._afterClosedSubject$.asObservable();
  }
}
